import React from 'react'
import get from 'lodash/get'

import { reduxForm } from 'redux-form'
import { generateValidation } from 'redux-form-validation'

import BaseModal from '../base-modal'
import {
  ModalForm,
  ModalFormRow,
  ModalFormBlock,
  CheckboxGroup
} from '../modal-form/modal-form'

const validations = {
  redoReason: { required: true, maxLength: 30 }
}

const ServicingRedoReasonForm = ({
  fields: {
    redoReason
  },
  servicing,
  loading,
  handleClose,
  handleSubmit,
  handleAddService,
  canAddServices,
  submitting
}) => {
  if (loading) {
    return <p>Loading...</p>
  }

  const redoReasonValid = redoReason.value && redoReason.value.length > 0 && redoReason.value.length <= 30
  const canSubmit = !loading && !submitting && redoReasonValid
  // console.log(canAddServices)
  const canAddServicesToServicing = servicing.status === 'completed' && servicing.approvalStatus === null && canAddServices
  // console.log(servicing)

  const permissions = servicing.permissions
  // console.log(canAddServicesToServicing && permissions.canAddServices)
  return (
    <BaseModal
      onClose={handleClose}
      title="Enter Redo Reason"
    >
      <ModalForm onSubmit={(data) => handleSubmit(data)}>
      <ModalFormRow smallMargin>
        <ModalFormBlock>
        <CheckboxGroup title="Redo Reason">
          <label key="appears_unfinished" onClick={e => redoReason.autofill('Appears Unfinished')}>
            <input
              type="radio"
              value="Appears Unfinished"
              checked={redoReason.value == 'Appears Unfinished'}
            />
            <span className='indicator' />
            Appears Unfinished
          </label>
          <label key="spots_still_there" onClick={e => redoReason.autofill('Spot(s) Still There')}>
            <input
              type="radio"
              value="Spot(s) Still There"
              checked={redoReason.value == 'Spot(s) Still There'}
            />
            <span className='indicator' />
            Spot(s) Still There
          </label>
          <label key="still_too_wet" onClick={e => redoReason.autofill('Still Too Wet')}>
            <input
              type="radio"
              value="Still Too Wet"
              checked={redoReason.value == 'Still Too Wet'}
            />
            <span className='indicator' />
            Still Too Wet
          </label>
          <label key="qa_audit_failure" onClick={e => redoReason.autofill('QA Audit Failure')}>
            <input
              type="radio"
              value="QA Audit Failure"
              checked={redoReason.value == 'QA Audit Failure'}
            />
            <span className='indicator'/>
            QA Audit Failure
          </label>
        </CheckboxGroup>
        </ModalFormBlock>
      </ModalFormRow>
      <ModalFormRow smallMargin>
        <ModalFormBlock>
          <label />
          {canAddServicesToServicing && permissions.canAddServices &&
            <button className='btn-danger' onClick={e => handleAddService(servicing)}>Add Another Service</button>
          }
        </ModalFormBlock>
      </ModalFormRow>
        <ModalFormRow smallMargin>
          <ModalFormBlock>
            <label></label>
              <textarea
                placeholder={"Other Reason: (max 30 characters)."}
                {...redoReason}
              />
          </ModalFormBlock>
        </ModalFormRow>
        <ModalFormRow>
          <div className='character-count'>
            <p>
              {(redoReason.value && redoReason.value.length) || 0} / 30 characters
            </p>
          </div>
        </ModalFormRow>
        <ModalFormRow>
          <ModalFormBlock submitButton>
            <button type='submit' disabled={!canSubmit}>Submit</button>
          </ModalFormBlock>
        </ModalFormRow>
      </ModalForm>
    </BaseModal>
  )
}

export default reduxForm({
  form: 'redoReason',
  ...generateValidation(validations)
})(ServicingRedoReasonForm)



// WEBPACK FOOTER //
// ./src/components/servicings/servicing-redo-reason-form.js